import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "mb-4" };
const _hoisted_2 = { class: "form-floating mb-3" };
const _hoisted_3 = { for: "company" };
const _hoisted_4 = { class: "form-floating mb-3" };
const _hoisted_5 = { for: "title" };
const _hoisted_6 = { class: "form-floating mb-3" };
const _hoisted_7 = { for: "firstname" };
const _hoisted_8 = { class: "form-floating mb-3" };
const _hoisted_9 = { for: "lastname" };
const _hoisted_10 = { class: "form-floating mb-3" };
const _hoisted_11 = { for: "email" };
const _hoisted_12 = { class: "form-floating mb-3" };
const _hoisted_13 = { for: "phone" };
const _hoisted_14 = { class: "form-floating mb-3" };
const _hoisted_15 = ["value"];
const _hoisted_16 = { for: "lang" };
const _hoisted_17 = { class: "form-check mb-3" };
const _hoisted_18 = {
    class: "form-check-label",
    for: "newsletterAbo"
};
const _hoisted_19 = { class: "mb-3" };
const _hoisted_20 = { class: "form-floating mb-3" };
const _hoisted_21 = { for: "oldPassword" };
const _hoisted_22 = { class: "form-floating mb-3" };
const _hoisted_23 = { for: "password" };
const _hoisted_24 = { class: "form-floating mb-3" };
const _hoisted_25 = { for: "password_confirmation" };
const _hoisted_26 = {
    key: 0,
    class: "text-danger fw-bold"
};
const _hoisted_27 = ["disabled"];
const _hoisted_28 = { class: "ms-2" };
const _hoisted_29 = { class: "ms-2" };
const _hoisted_30 = { class: "d-flex justify-content-end" };
const _hoisted_31 = { class: "p-3" };
const _hoisted_32 = { key: 0 };
const _hoisted_33 = ["onClick"];
const _hoisted_34 = {
    key: 0,
    class: "d-flex flex-wrap"
};
const _hoisted_35 = ["onClick"];
const _hoisted_36 = {
    key: 1,
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "currentColor",
    class: "bi bi-x-circle text-muted",
    viewBox: "0 0 16 16"
};
const _hoisted_37 = { class: "mb-5" };
const _hoisted_38 = { class: "fw-bold mb-3 gallery-font-color" };
const _hoisted_39 = { class: "form-floating mb-3" };
const _hoisted_40 = { for: "newAddressCompany" };
const _hoisted_41 = { class: "form-floating mb-3" };
const _hoisted_42 = { for: "newAddressFirstname" };
const _hoisted_43 = { class: "form-floating mb-3" };
const _hoisted_44 = { for: "newAddressLastname" };
const _hoisted_45 = { class: "form-floating mb-3" };
const _hoisted_46 = { for: "newAddressStreet" };
const _hoisted_47 = { class: "form-floating mb-3" };
const _hoisted_48 = { for: "newAddressZipcode" };
const _hoisted_49 = { class: "form-floating mb-3" };
const _hoisted_50 = { for: "newAddressCity" };
const _hoisted_51 = { class: "form-floating mb-3" };
const _hoisted_52 = ["value"];
const _hoisted_53 = { for: "newAddressCountry" };
const _hoisted_54 = { class: "form-check mb-3" };
const _hoisted_55 = {
    class: "form-check-label",
    for: "newAddressIsDefault"
};
const _hoisted_56 = {
    type: "submit",
    class: "btn btn-success d-inline-flex align-items-center"
};
const _hoisted_57 = { class: "ms-2" };
import { FilterMatchMode } from '@primevue/core/api';
import axios from 'axios';
import { onMounted, ref } from 'vue';
import ContextModal from './ContextModal.vue';
import { responseMessages } from '@/Composables/responseMessages';
import { useI18n } from 'vue-i18n';
import { router, useForm, usePage } from '@inertiajs/vue3';
import { Column, DataTable } from 'primevue';
import Swal from 'sweetalert2';
import YesNoIcon from '@/Shared/YesNoIcon.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CustomerDetails',
    props: {
        order: Object,
        countries: {
            type: Object,
            required: true
        },
        languages: {
            type: Object,
            required: true
        },
    },
    setup(__props) {
        let { showErrorSwal, showSuccessSwal } = responseMessages();
        const { t } = useI18n();
        const props = __props;
        const user = ref(usePage().props.auth.user);
        const customer = ref(usePage().props.auth.customer);
        const addresses = ref(customer.value ? customer.value.addresses : []);
        const createAddressModal = ref();
        const tableFilter = ref({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        });
        const editCustomerForm = useForm({
            company: null,
            title: null,
            firstname: null,
            lastname: null,
            email: null,
            phone: null,
            newsletterAbo: false,
            lang: 'de',
            oldPassword: null,
            password: null,
            passwordConfirmation: null
        });
        const createAddressForm = useForm({
            company: null,
            firstname: null,
            lastname: null,
            address: null,
            city: null,
            zipcode: null,
            country: null,
            isDefault: false
        });
        onMounted(() => {
            loadUserData();
            loadAddreses();
        });
        function loadUserData() {
            axios.get(route('configurator.userLoader.load'))
                .then(function (response) {
                user.value = response.data.user;
                customer.value = response.data.customer;
                editCustomerForm.company = customer.value ? customer.value.company : null;
                editCustomerForm.title = customer.value ? customer.value.title : null;
                editCustomerForm.firstname = customer.value ? customer.value.firstname : null;
                editCustomerForm.lastname = customer.value ? customer.value.lastname : null;
                editCustomerForm.email = customer.value ? customer.value.email : null;
                editCustomerForm.phone = customer.value ? customer.value.phone : null;
                editCustomerForm.newsletterAbo = customer.value ? customer.value.newsletterAbo : false;
                editCustomerForm.lang = customer.value ? customer.value.lang : 'de';
            })
                .catch(function (error) {
                console.log(error);
            });
        }
        function loadAddreses() {
            axios.post(route('customer.addresses.load'))
                .then(function (response) {
                addresses.value = response.data;
            })
                .catch(function (error) {
                console.log(error);
            });
        }
        function updateCustomer() {
            editCustomerForm.transform((data) => ({
                company: data.company,
                title: data.title,
                firstname: data.firstname,
                lastname: data.lastname,
                email: data.email,
                phone: data.phone,
                newsletter_abo: data.newsletterAbo,
                lang: data.lang,
                old_password: data.oldPassword,
                password: data.password,
                password_confirmation: data.passwordConfirmation
            })).submit('put', route('customer.profile.update', customer.value.uuid), {
                preserveScroll: true,
                onSuccess: page => {
                    const flash = page.props.flash;
                    if (flash?.error) {
                        showErrorSwal(flash.error);
                        return;
                    }
                    showSuccessSwal(t('Kundendaten aktualisiert'));
                },
                onError: errors => {
                    console.log(errors);
                    showErrorSwal(errors[0]);
                }
            });
        }
        function createAddress() {
            createAddressForm.transform((data) => ({
                company: data.company,
                firstname: data.firstname,
                lastname: data.lastname,
                address: data.address,
                city: data.city,
                zipcode: data.zipcode,
                country: data.country,
                is_default: data.isDefault
            })).submit('post', route('customer.addresses.store', customer.value.uuid), {
                preserveScroll: true,
                onSuccess: page => {
                    showSuccessSwal(t('Adresse hinzugefügt'));
                    createAddressForm.reset();
                    loadAddreses();
                    if (createAddressModal.value) {
                        createAddressModal.value.close();
                    }
                },
                onError: errors => {
                    console.log(errors);
                    showErrorSwal(errors[0]);
                }
            });
        }
        function setDefaultAdress(address) {
            router.put(route('customer.addresses.setDefault', address.uuid), {}, {
                preserveScroll: true,
                onSuccess: page => {
                    loadAddreses();
                    showSuccessSwal(t('Adresse als Standard gesetzt'));
                },
                onError: errors => {
                    console.log(errors);
                    showErrorSwal(errors[0]);
                }
            });
        }
        function removeAddress(address) {
            Swal.fire({
                title: t('Adresse löschen?'),
                text: t('Soll die Adresse wirklich gelöscht werden?'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: t("Ja, löschen"),
                cancelButtonText: t("Abbrechen"),
                confirmButtonColor: "#528399",
                cancelButtonColor: "#dc3545",
            }).then((result) => {
                if (result.isConfirmed) {
                    router.delete(route('customer.addresses.destroy', address.uuid), {
                        preserveScroll: true,
                        onSuccess: page => {
                            loadAddreses();
                            showSuccessSwal('Adresse gelöscht');
                        },
                        onError: errors => {
                            console.log(errors);
                            showErrorSwal(errors[0]);
                        }
                    });
                }
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("form", {
                            onSubmit: _withModifiers(updateCustomer, ["prevent"])
                        }, [
                            _createElementVNode("div", _hoisted_2, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    id: "company",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(editCustomerForm).company) = $event))
                                }, null, 512), [
                                    [_vModelText, _unref(editCustomerForm).company]
                                ]),
                                _createElementVNode("label", _hoisted_3, _toDisplayString(_unref(t)('Firma (optional)')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_4, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    id: "title",
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(editCustomerForm).title) = $event))
                                }, null, 512), [
                                    [_vModelText, _unref(editCustomerForm).title]
                                ]),
                                _createElementVNode("label", _hoisted_5, _toDisplayString(_unref(t)('Titel (optional)')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_6, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    id: "firstname",
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(editCustomerForm).firstname) = $event)),
                                    required: ""
                                }, null, 512), [
                                    [_vModelText, _unref(editCustomerForm).firstname]
                                ]),
                                _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(t)('Vorname')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    id: "lastname",
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(editCustomerForm).lastname) = $event)),
                                    required: ""
                                }, null, 512), [
                                    [_vModelText, _unref(editCustomerForm).lastname]
                                ]),
                                _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(t)('Nachname')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "email",
                                    class: "form-control",
                                    id: "email",
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(editCustomerForm).email) = $event)),
                                    required: ""
                                }, null, 512), [
                                    [_vModelText, _unref(editCustomerForm).email]
                                ]),
                                _createElementVNode("label", _hoisted_11, _toDisplayString(_unref(t)('E-Mail')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_12, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    id: "phone",
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(editCustomerForm).phone) = $event)),
                                    required: ""
                                }, null, 512), [
                                    [_vModelText, _unref(editCustomerForm).phone]
                                ]),
                                _createElementVNode("label", _hoisted_13, _toDisplayString(_unref(t)('Telefon')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_14, [
                                _withDirectives(_createElementVNode("select", {
                                    class: "form-select",
                                    id: "lang",
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_unref(editCustomerForm).lang) = $event)),
                                    required: ""
                                }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.languages, (language, index) => {
                                        return (_openBlock(), _createElementBlock("option", { value: index }, _toDisplayString(language), 9, _hoisted_15));
                                    }), 256))
                                ], 512), [
                                    [_vModelSelect, _unref(editCustomerForm).lang]
                                ]),
                                _createElementVNode("label", _hoisted_16, _toDisplayString(_unref(t)('Sprache')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                                _withDirectives(_createElementVNode("input", {
                                    class: "form-check-input",
                                    type: "checkbox",
                                    value: "1",
                                    id: "newsletterAbo",
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_unref(editCustomerForm).newsletterAbo) = $event))
                                }, null, 512), [
                                    [_vModelCheckbox, _unref(editCustomerForm).newsletterAbo]
                                ]),
                                _createElementVNode("label", _hoisted_18, _toDisplayString(_unref(t)('Ich möchte den Newsletter abonnieren')), 1)
                            ]),
                            _createElementVNode("h4", _hoisted_19, _toDisplayString(_unref(t)('Neues Passwort (optional)')), 1),
                            _createElementVNode("div", _hoisted_20, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "password",
                                    class: "form-control",
                                    id: "oldPassword",
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_unref(editCustomerForm).oldPassword) = $event)),
                                    required: ""
                                }, null, 512), [
                                    [_vModelText, _unref(editCustomerForm).oldPassword]
                                ]),
                                _createElementVNode("label", _hoisted_21, _toDisplayString(_unref(t)('Altes Passwort')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_22, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "password",
                                    class: "form-control",
                                    id: "password",
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_unref(editCustomerForm).password) = $event)),
                                    required: ""
                                }, null, 512), [
                                    [_vModelText, _unref(editCustomerForm).password]
                                ]),
                                _createElementVNode("label", _hoisted_23, _toDisplayString(_unref(t)('Neues Passwort')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_24, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "password",
                                    class: "form-control",
                                    id: "password_confirmation",
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_unref(editCustomerForm).passwordConfirmation) = $event)),
                                    required: ""
                                }, null, 512), [
                                    [_vModelText, _unref(editCustomerForm).passwordConfirmation]
                                ]),
                                _createElementVNode("label", _hoisted_25, _toDisplayString(_unref(t)('Passwort bestätigen')), 1)
                            ]),
                            (_unref(editCustomerForm).password !== _unref(editCustomerForm).passwordConfirmation)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(_unref(t)('Passwörter stimmen nicht überein')), 1))
                                : _createCommentVNode("", true),
                            _createElementVNode("button", {
                                type: "submit",
                                class: "btn btn-success d-inline-flex align-items-center",
                                disabled: _unref(editCustomerForm).password !== _unref(editCustomerForm).passwordConfirmation
                            }, [
                                _cache[22] || (_cache[22] = _createElementVNode("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "16",
                                    height: "16",
                                    fill: "currentColor",
                                    class: "bi bi-check2",
                                    viewBox: "0 0 16 16"
                                }, [
                                    _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                ], -1)),
                                _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(t)('Änderungen speichern')), 1)
                            ], 8, _hoisted_27)
                        ], 32)
                    ]),
                    _createElementVNode("div", null, [
                        _createElementVNode("button", {
                            class: "btn btn-secondary d-inline-flex align-items-center",
                            onClick: _cache[11] || (_cache[11] = ($event) => (createAddressModal.value.open()))
                        }, [
                            _cache[23] || (_cache[23] = _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                fill: "currentColor",
                                class: "bi bi-plus-lg",
                                viewBox: "0 0 16 16"
                            }, [
                                _createElementVNode("path", {
                                    "fill-rule": "evenodd",
                                    d: "M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"
                                })
                            ], -1)),
                            _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(t)('Neue Adresse')), 1)
                        ]),
                        _createVNode(_unref(DataTable), {
                            dataKey: "id",
                            value: addresses.value,
                            stripedRows: "",
                            responsiveLayout: "scroll",
                            globalFilterFields: ['company', 'lastname', 'address', 'city', 'zipcode', 'country', 'isDefault'],
                            filters: tableFilter.value,
                            "onUpdate:filters": _cache[13] || (_cache[13] = ($event) => ((tableFilter).value = $event)),
                            paginator: true,
                            rows: 10,
                            paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
                            rowsPerPageOptions: [10, 25, 50, 150],
                            currentPageReportTemplate: "{first} von {last} von insgesamt {totalRecords}"
                        }, {
                            header: _withCtx(() => [
                                _createElementVNode("div", _hoisted_30, [
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: "form-control",
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((tableFilter.value['global'].value) = $event)),
                                        placeholder: "Suche",
                                        style: { "width": "250px" }
                                    }, null, 512), [
                                        [_vModelText, tableFilter.value['global'].value]
                                    ])
                                ])
                            ]),
                            empty: _withCtx(() => [
                                _createElementVNode("div", _hoisted_31, _toDisplayString(_unref(t)('Keine Adressen gefunden')), 1)
                            ]),
                            loading: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('Einträge werden geladen ...')), 1)
                            ]),
                            default: _withCtx(() => [
                                _createVNode(_unref(Column), {
                                    header: "#",
                                    sortable: true
                                }, {
                                    body: _withCtx((slotProps) => [
                                        _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_unref(Column), {
                                    field: "company",
                                    header: _unref(t)('Firma'),
                                    sortable: true,
                                    sortField: "company"
                                }, null, 8, ["header"]),
                                _createVNode(_unref(Column), {
                                    header: _unref(t)('Name'),
                                    sortable: true,
                                    sortField: "lastname"
                                }, {
                                    body: _withCtx((slotProps) => [
                                        _createTextVNode(_toDisplayString(slotProps.data.firstname) + " " + _toDisplayString(slotProps.data.lastname), 1)
                                    ]),
                                    _: 1
                                }, 8, ["header"]),
                                _createVNode(_unref(Column), {
                                    field: "address",
                                    header: _unref(t)('Adresse'),
                                    sortable: true,
                                    sortField: "address"
                                }, null, 8, ["header"]),
                                _createVNode(_unref(Column), {
                                    field: "city",
                                    header: _unref(t)('Stadt'),
                                    sortable: true,
                                    sortField: "city"
                                }, null, 8, ["header"]),
                                _createVNode(_unref(Column), {
                                    field: "zipcode",
                                    header: _unref(t)('Postleitzahl'),
                                    sortable: true,
                                    sortField: "zipcode"
                                }, null, 8, ["header"]),
                                _createVNode(_unref(Column), {
                                    field: "country",
                                    header: _unref(t)('Land'),
                                    sortable: true,
                                    sortField: "country"
                                }, null, 8, ["header"]),
                                _createVNode(_unref(Column), {
                                    header: _unref(t)('Standard-Adresse'),
                                    sortable: true,
                                    sortField: "isDefault"
                                }, {
                                    body: _withCtx((slotProps) => [
                                        (!slotProps.data.isDefault)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                                _createElementVNode("button", {
                                                    class: "btn",
                                                    onClick: ($event) => (setDefaultAdress(slotProps.data))
                                                }, [
                                                    _createVNode(YesNoIcon, {
                                                        answer: slotProps.data.isDefault
                                                    }, null, 8, ["answer"])
                                                ], 8, _hoisted_33)
                                            ]))
                                            : _createCommentVNode("", true),
                                        (slotProps.data.isDefault)
                                            ? (_openBlock(), _createBlock(YesNoIcon, {
                                                key: 1,
                                                answer: slotProps.data.isDefault
                                            }, null, 8, ["answer"]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                }, 8, ["header"]),
                                _createVNode(_unref(Column), { header: "" }, {
                                    body: _withCtx((slotProps) => [
                                        (slotProps.data.canRemove)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                                _createElementVNode("button", {
                                                    class: "btn",
                                                    onClick: ($event) => (removeAddress(slotProps.data))
                                                }, [...(_cache[24] || (_cache[24] = [
                                                        _createElementVNode("svg", {
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            width: "16",
                                                            height: "16",
                                                            fill: "currentColor",
                                                            class: "bi bi-x-circle text-danger",
                                                            viewBox: "0 0 16 16"
                                                        }, [
                                                            _createElementVNode("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" }),
                                                            _createElementVNode("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" })
                                                        ], -1)
                                                    ]))], 8, _hoisted_35)
                                            ]))
                                            : _createCommentVNode("", true),
                                        (!slotProps.data.canRemove)
                                            ? (_openBlock(), _createElementBlock("svg", _hoisted_36, [...(_cache[25] || (_cache[25] = [
                                                    _createElementVNode("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" }, null, -1),
                                                    _createElementVNode("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" }, null, -1)
                                                ]))]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }, 8, ["value", "filters"])
                    ])
                ]),
                _createVNode(ContextModal, {
                    ref_key: "createAddressModal",
                    ref: createAddressModal
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("h3", _hoisted_38, _toDisplayString(_unref(t)('Neue Adresse')), 1),
                            _createElementVNode("form", {
                                onSubmit: _withModifiers(createAddress, ["prevent"])
                            }, [
                                _createElementVNode("div", _hoisted_39, [
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: "form-control",
                                        id: "newAddressCompany",
                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_unref(createAddressForm).company) = $event))
                                    }, null, 512), [
                                        [_vModelText, _unref(createAddressForm).company]
                                    ]),
                                    _createElementVNode("label", _hoisted_40, _toDisplayString(_unref(t)('Firma')), 1)
                                ]),
                                _createElementVNode("div", _hoisted_41, [
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: "form-control",
                                        id: "newAddressFirstname",
                                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((_unref(createAddressForm).firstname) = $event))
                                    }, null, 512), [
                                        [_vModelText, _unref(createAddressForm).firstname]
                                    ]),
                                    _createElementVNode("label", _hoisted_42, _toDisplayString(_unref(t)('Vorname')), 1)
                                ]),
                                _createElementVNode("div", _hoisted_43, [
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: "form-control",
                                        id: "newAddressLastname",
                                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((_unref(createAddressForm).lastname) = $event))
                                    }, null, 512), [
                                        [_vModelText, _unref(createAddressForm).lastname]
                                    ]),
                                    _createElementVNode("label", _hoisted_44, _toDisplayString(_unref(t)('Nachname')), 1)
                                ]),
                                _createElementVNode("div", _hoisted_45, [
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: "form-control",
                                        id: "newAddressStreet",
                                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((_unref(createAddressForm).address) = $event)),
                                        required: ""
                                    }, null, 512), [
                                        [_vModelText, _unref(createAddressForm).address]
                                    ]),
                                    _createElementVNode("label", _hoisted_46, _toDisplayString(_unref(t)('Adresse')), 1)
                                ]),
                                _createElementVNode("div", _hoisted_47, [
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: "form-control",
                                        id: "newAddressZipcode",
                                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((_unref(createAddressForm).zipcode) = $event)),
                                        required: ""
                                    }, null, 512), [
                                        [_vModelText, _unref(createAddressForm).zipcode]
                                    ]),
                                    _createElementVNode("label", _hoisted_48, _toDisplayString(_unref(t)('Postleitzahl')), 1)
                                ]),
                                _createElementVNode("div", _hoisted_49, [
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: "form-control",
                                        id: "newAddressCity",
                                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((_unref(createAddressForm).city) = $event)),
                                        required: ""
                                    }, null, 512), [
                                        [_vModelText, _unref(createAddressForm).city]
                                    ]),
                                    _createElementVNode("label", _hoisted_50, _toDisplayString(_unref(t)('Stadt')), 1)
                                ]),
                                _createElementVNode("div", _hoisted_51, [
                                    _withDirectives(_createElementVNode("select", {
                                        class: "form-select",
                                        id: "newAddressCountry",
                                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((_unref(createAddressForm).country) = $event))
                                    }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.countries, (country) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                value: country.id
                                            }, _toDisplayString(country.name), 9, _hoisted_52));
                                        }), 256))
                                    ], 512), [
                                        [_vModelSelect, _unref(createAddressForm).country]
                                    ]),
                                    _createElementVNode("label", _hoisted_53, _toDisplayString(_unref(t)('Land')), 1)
                                ]),
                                _createElementVNode("div", _hoisted_54, [
                                    _withDirectives(_createElementVNode("input", {
                                        class: "form-check-input",
                                        type: "checkbox",
                                        value: "1",
                                        id: "newAddressIsDefault",
                                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => ((_unref(createAddressForm).isDefault) = $event))
                                    }, null, 512), [
                                        [_vModelCheckbox, _unref(createAddressForm).isDefault]
                                    ]),
                                    _createElementVNode("label", _hoisted_55, _toDisplayString(_unref(t)('Standard-Adresse?')), 1)
                                ]),
                                _createElementVNode("button", _hoisted_56, [
                                    _cache[26] || (_cache[26] = _createElementVNode("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "16",
                                        height: "16",
                                        fill: "currentColor",
                                        class: "bi bi-check2",
                                        viewBox: "0 0 16 16"
                                    }, [
                                        _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                    ], -1)),
                                    _createElementVNode("span", _hoisted_57, _toDisplayString(_unref(t)('Speichern')), 1)
                                ])
                            ], 32)
                        ])
                    ]),
                    _: 1
                }, 512)
            ], 64));
        };
    }
});
